export default __webpack_public_path__ + "static/media/10-gram-generic-gold-bar-999-fine-ira-approved-secondary-market--132084725156879268.3cf8c675.jpg";